<template>
  <div class="basic-data-container">
    <h2>基础资料管理</h2>
    <p class="page-description">
      按权限展示可维护的基础数据入口；无权限的卡片不会显示。
      说明：菜单与路由通常只校验各模块的<strong>查看</strong>权限；能否新增、编辑、删除由后端校验对应模块的<strong>编辑</strong>权限（如「颜色资料-编辑」「计量单位-编辑」）。
      若仅有查看权限，页面可能仍能打开，但保存或删除时会提示无权限——请在<strong>系统管理 → 角色权限</strong>中为该角色勾选相应模块的编辑权限。
    </p>

    <el-row :gutter="20" class="data-cards">
      <el-col v-if="can('customers.brands.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/brands')">
          <div class="card-icon" style="color: #409EFF;">
            <el-icon><PriceTag /></el-icon>
          </div>
          <div class="card-title">品牌管理</div>
          <div class="card-desc">管理产品品牌信息</div>
        </el-card>
      </el-col>

      <el-col v-if="can('masterdata.colors.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/colors')">
          <div class="card-icon" style="color: #67C23A;">
            <el-icon><Brush /></el-icon>
          </div>
          <div class="card-title">颜色管理</div>
          <div class="card-desc">管理颜色代码和名称</div>
        </el-card>
      </el-col>

      <el-col v-if="can('customers.records.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/customers')">
          <div class="card-icon" style="color: #E6A23C;">
            <el-icon><User /></el-icon>
          </div>
          <div class="card-title">客户管理</div>
          <div class="card-desc">管理客户信息和地址</div>
        </el-card>
      </el-col>

      <el-col v-if="can('purchase.suppliers.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/suppliers')">
          <div class="card-icon" style="color: #8E44AD;">
            <el-icon><Shop /></el-icon>
          </div>
          <div class="card-title">供应商管理</div>
          <div class="card-desc">管理供应商信息和联系方式</div>
        </el-card>
      </el-col>

      <el-col v-if="can('masterdata.materials.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/materials')">
          <div class="card-icon" style="color: #F56C6C;">
            <el-icon><Goods /></el-icon>
          </div>
          <div class="card-title">材料管理</div>
          <div class="card-desc">管理材料品类和规格</div>
        </el-card>
      </el-col>

      <el-col v-if="can('masterdata.material_customer_names.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/material-customer-names')">
          <div class="card-icon" style="color: #36b37e;">
            <el-icon><Tickets /></el-icon>
          </div>
          <div class="card-title">客户材料名称</div>
          <div class="card-desc">集中维护客户叫法映射</div>
        </el-card>
      </el-col>

      <el-col v-if="can('masterdata.order_types.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/order-types')">
          <div class="card-icon" style="color: #909399;">
            <el-icon><Document /></el-icon>
          </div>
          <div class="card-title">订单类型</div>
          <div class="card-desc">管理订单分类和属性</div>
        </el-card>
      </el-col>

      <el-col v-if="can('masterdata.seasons.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/seasons')">
          <div class="card-icon" style="color: #FF9900;">
            <el-icon><Calendar /></el-icon>
          </div>
          <div class="card-title">季节管理</div>
          <div class="card-desc">管理产品季节信息</div>
        </el-card>
      </el-col>

      <el-col v-if="can('masterdata.units.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/units')">
          <div class="card-icon" style="color: #53a8ff;">
            <el-icon><ScaleToOriginal /></el-icon>
          </div>
          <div class="card-title">单位管理</div>
          <div class="card-desc">管理计量单位和换算</div>
        </el-card>
      </el-col>

      <el-col v-if="can('masterdata.unit_conversions.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/unit-conversions')">
          <div class="card-icon" style="color: #20b2aa;">
            <el-icon><Switch /></el-icon>
          </div>
          <div class="card-title">单位换算规则</div>
          <div class="card-desc">管理单位之间的换算规则</div>
        </el-card>
      </el-col>

      <el-col v-if="can('masterdata.numbering_rules.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/numbering-rules')">
          <div class="card-icon" style="color: #9c27b0;">
            <el-icon><SetUp /></el-icon>
          </div>
          <div class="card-title">编码规则</div>
          <div class="card-desc">管理自动编号规则</div>
        </el-card>
      </el-col>

      <el-col v-if="can('masterdata.tax_classifications.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/tax-classifications')">
          <div class="card-icon" style="color: #13CE66;">
            <el-icon><Document /></el-icon>
          </div>
          <div class="card-title">税务分类</div>
          <div class="card-desc">管理开票品名分类</div>
        </el-card>
      </el-col>

      <el-col v-if="can('masterdata.print_templates.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/print-templates')">
          <div class="card-icon" style="color: #722ed1;">
            <el-icon><Printer /></el-icon>
          </div>
          <div class="card-title">打印模板</div>
          <div class="card-desc">管理业务打印模板</div>
        </el-card>
      </el-col>

      <el-col v-if="can('masterdata.specifications.view')" :xs="12" :sm="8" :md="6" :lg="4">
        <el-card class="data-card" shadow="hover" @click="$router.push('/specification-templates')">
          <div class="card-icon" style="color: #2d8cf0;">
            <el-icon><Grid /></el-icon>
          </div>
          <div class="card-title">规格主数据</div>
          <div class="card-desc">厚度/克重与宽幅组合，供订单规格选用</div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import {
  PriceTag,
  Brush,
  User,
  Goods,
  Document,
  Calendar,
  ScaleToOriginal,
  SetUp,
  Shop,
  Switch,
  Tickets,
  Printer,
  Grid
} from '@element-plus/icons-vue'
import { useUserStore } from '@/store/user'
import { hasPermission } from '@/utils/permission'

const userStore = useUserStore()

const can = (key) => hasPermission(userStore.user, key)

onMounted(() => {
  userStore.initFromStorage()
  userStore.syncUserFromServer({ force: true })
})
</script>

<style scoped>
.basic-data-container {
  padding: 20px;
}

.page-description {
  color: #909399;
  margin-bottom: 30px;
}

.data-cards {
  margin-top: 20px;
}

.data-card {
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 20px;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.data-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.card-icon {
  font-size: 36px;
  margin-bottom: 10px;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.card-desc {
  font-size: 12px;
  color: #909399;
}
</style>
